<template lang="pug">
  div.alert-container
    v-alert(
      type="success"
      dismissible
      transition="scale-transition"
      v-model="showSuccess"
    ) {{ alert.message }}
    v-alert(
      type="info"
      dismissible
      transition="scale-transition"
      v-model="showInfo"
    ) {{ alert.message }}
    v-alert(
      type="warning"
      dismissible
      transition="scale-transition"
      v-model="showWarning"
    ) {{ alert.message }}
    v-alert(
      type="error"
      dismissible
      transition="scale-transition"
      v-model="showError"
    ) {{ alert.message }}
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'Alert',

    data() {
        return {
            showSuccess: false,
            showInfo: false,
            showWarning: false,
            showError: false
        };
    },

    computed: {
        ...mapState({
            alert: state => state.appearance.alert
        })
    },

    watch: {
        alert(newAlert) {
            if (newAlert) {
                this.showWhich(newAlert.type);
            } else {
                this.hideAll();
            }
        }
    },

    methods: {
        hideAll() {
            this.showSuccess = false;
            this.showInfo = false;
            this.showWarning = false;
            this.showError = false;
        },

        showWhich(type) {
            this.showSuccess = (type === 'success');
            this.showInfo = (type === 'info');
            this.showWarning = (type === 'warning');
            this.showError = (type === 'error');
        }
    }
};
</script>

<style>
  #alert-container {
    position: relative;
  }

  .alert {
    position: absolute;
    right: 0;
    width: 60%;
    z-index: 1000;
  }
</style>



// WEBPACK FOOTER //
// src/components/core/Alert.vue